import * as React from "react";
import cn from "classnames";
import styled, { css } from "../../../styled/index";
import { shadeAlternate } from "../../../styled/helpers";
const Label = styled("label") `
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  font-size: ${({ theme }) => theme.font.size}px;
  user-select: none;
  &:hover {
    input ~ .checkmark {
      background-color: ${({ theme }) => shadeAlternate(0.2, theme.input.background)};
    }
  }
  
  input:checked ~ .checkmark {
  ${(props) => props.version === 'v2' ? css `
      border: 1px solid ${({ theme }) => theme.colors.primary};
    ` : css `
      background-color: ${({ theme }) => theme.colors.primary};
      border: 1px solid ${({ theme }) => theme.colors.primary};
    `};

    
    &:after {
      display: block;
    }
  }
`;
const Input = styled("input") `
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;
const Checkmark = styled("span") `
  height: 18px;
  width: 18px;
  margin-right: 8px;
  ${(props) => props.version === 'v2' ? css `
      background-color: ${({ theme }) => theme.colors.primary_text};
      border: 1px solid ${({ theme }) => theme.colors.text};
    ` : css `
      background-color: ${({ theme }) => shadeAlternate(0.1, theme.input.background)};
      border: 1px solid ${({ theme }) => theme.input.border};
    `};
  
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s all;
  &:after {
    content: "";
    display: none;
    ${(props) => props.version === 'v2' ? css `
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: ${({ theme }) => theme.colors.primary};
    ` : css `
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: ${({ theme }) => theme.colors.primary_text};
    `};
    
  }
`;
export const Radio = (props) => {
    const { id, name, required, title, value, onChange, checked, className, version = 'v1' } = props;
    return (React.createElement(Label, { version: version },
        React.createElement(Input, { id: id, type: "radio", className: cn(className), name: name, onChange: onChange, checked: checked, value: value, required: required }),
        React.createElement(Checkmark, { className: "checkmark", version: version }),
        title));
};
//# sourceMappingURL=Radio.js.map